<template>
   <div :class="{'show':show}" class="vedio" ref="vedio2"> 
       <i v-show="vedioOn" class="el-icon-bell vediosvg"  @click="vedioOffHandle" title="告警声音开关（当前状态为打开）" ></i>
       <i v-show="!vedioOn"  class="el-icon-close-notification vediosvg" :class="{isforswitch:!switchAllStatus}" title="告警声音开关（当前状态为关闭）" @click="vedioOnHandle"></i>
       <!-- <i class="el-icon-switch-button vediosvg"  @click="handleVedio" title="告警声音开关（当前状态为打开111）" ></i> -->
   </div> 
</template>

<script>
import Cookies from 'js-cookie'
import { getVedioList } from '@/api/auditing'
// 警戒状态
var warningVedioEnum = {
  '0': './static/vedio/test.mp3',
  '1': './static/vedio/12001.mp3',
  '2': './static/vedio/12002.mp3',
  '3': './static/vedio/12003.mp3',
  '4': './static/vedio/12004.mp3'
}
export default {
  name: 'vedioPlay',
  data() {
    return {
      show: true,
      autoplay: false,//当前环境，此时，音频播放器是否能自动播放
      switchAllStatus: Cookies.get('vedioAllSwitch')=="0"?false:true,//最新告警声音开关状态(最顶部，总开关)，如果第一次打开(刷新)则为原始保存告警声音开关状态,新操作将更新
      audio:null,
      vedioIsPlaying:false,
      warningVedioOptions:warningVedioEnum,
      vedioWarnLevel:"0",
      replayNum:0,//重复播放次数
      istestOnce:true,//测试播放
      vedioWarnDuration:60//播放时长限制，s
    }
  },
  watch: {
    /**注册 监听告警(监控主页)页面告警信息的播放状态 事件，控制播放、暂停 */
    warnStatus(value){
      if(isFinite(value.warnlevel)){
        this.vedioWarnLevel=value.warnlevel;
      }
      this.vedioPlayControl(this.vedioWarnLevel);
    }
  },
  computed: {
    /** 专用标识总开关状态是否为打开，或标识是否可播放，可播放条件：1.手动打开全局播放控件 2.当前环境可自动播放 */
    vedioOn() {
      return this.switchAllStatus&&this.autoplay
    },
    /**监听告警(监控主页)页面告警信息的播放状态 */
    warnStatus(){
      return {
        warnswitchsta: this.$store.state.vedio.warnswitchsta,
        warnlevel:this.$store.state.vedio.warnlevel,
        switchAllStatus: this.switchAllStatus,
        autoplay:this.autoplay
      }
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.initVedio();
  },
  methods: {
    /**打开音频 */
    vedioOnHandle() {
      this.switchAllStatus=true;
      this.$store.dispatch('vedio/setSwitchAllStatus', "1")
      console.log("打开音频播放按钮")
    },
    getList() {
      getVedioList({ pageNO: 1,pageSize: 20,conQuery: {}}).then(response => {
        if (!response.result) {
          const list = response.data.rows
          list.forEach(item=>{
             if(item.SYSCODE=="GUARDZ_MUSIC"){
                this.warningVedioOptions['1']='./static/vedio/'+item.SYSVALUE;
             }
             else if(item.SYSCODE=="LIMITZ_MUSIC"){
                this.warningVedioOptions['2']='./static/vedio/'+item.SYSVALUE;
             }
            else if(item.SYSCODE=="GUARANTEEZ_MUSIC"){
                this.warningVedioOptions['3']='./static/vedio/'+item.SYSVALUE;
             }
            else if(item.SYSCODE=="HISTORYZ_MUSIC"){
                this.warningVedioOptions['4']='./static/vedio/'+item.SYSVALUE;
             }
          })

        } else {
          // this.$notify({
          //   title: '错误',
          //   message: response.message,
          //   type: 'error',
          //   duration: 2000
          // })
        }
      })
    },
    /**关闭音频 */
    vedioOffHandle() {
      this.switchAllStatus=false;
      this.$store.dispatch('vedio/setSwitchAllStatus', "0")
      console.log("关闭音频播放按钮")
    },
    /** 切换 播放或暂停音频播放 */
    handleVedio() {
      if (this.vedioIsPlaying) { // 播放中--->暂停
        this.vedioPause()
      } else { // 暂停中--->重新播放
        this.vedioReplay()// this.vedioPlay()
      }
    },
    /**播放正式音频文件 */
    vedioPlayControl(){
        if(this.vedioOn&&this.warnStatus.warnswitchsta=="1"){//播放
          this.vedioPlay()
        }
        else{ //暂停
          this.vedioPause()
        }
    },
    /** 控制 音频播放 */
    vedioPlay() {
      console.info('vedioPlay:')
      this.vedioIsPlaying = true
      if (this.audio&&this.audio.currentTime>0) {
          this.audio.pause()
          //this.audio = null
      }
      this.audio.src = this.warningVedioOptions[this.vedioWarnLevel]// './static/vedio/12637.mp3' // 'http://downsc.chinaz.net/Files/DownLoad/sound1/202003/12637.mp3'
      this.audio.muted=false;//非静音
      this.$store.dispatch('vedio/setWarnPlayEnd', "0")
      this.audio.load();
      // play返回的是一个promise
      this.audio.play().then(() => {
          // 支持自动播放
          this.replayNum = 0;
      }).catch(err => { // 音频加载失败
          console.error("音频加载失败"+err)
      }).finally(() => { // 告诉调用者结果
          //audio.remove();
      });
    },
     /** 控制 音频暂停 */
    vedioPause() {
      console.info('vedioPause:')
      this.vedioIsPlaying = false
      // 暂停
      if (this.audio) { this.audio.pause() }
    },
    /** 控制 音频重播 */
    vedioReplay() {
      console.info('vedioReplay:')
      this.vedioIsPlaying = true
      this.vedioPlayControl();
    },
    /**创建音频播放器并测试是否能正常播放 */
    testAutoPlay () {
        // 返回一个promise以告诉调用者检测结果
        return new Promise(resolve => {
            this.audio = document.createElement('audio');
            // require一个本地文件，会变成base64格式
            this.audio.id="globalaudio";
            this.audio.src = require('@/../public/static/vedio/test.mp3');
            //this.audio.muted=true;//静音
            this.istestOnce=true
            //this.audio.currentTime=6.0865;
            document.body.appendChild(this.audio);
            let autoplay = true;
            // play返回的是一个promise
            this.audio.play().then(() => {
                // 支持自动播放
                autoplay = true;
            }).catch(err => {
                // 不支持自动播放
                autoplay = false;
            }).finally(() => {
                //audio.remove();
                // 告诉调用者结果
                resolve(autoplay);
            });
        });
    },
    /** 初始化音频播放器 */
    initVedio () {
        // 检测是否能自动播放
        this.testAutoPlay().then(autoplay => {
            if (!this.autoplay) {
              this.autoplay = autoplay;
              this.$store.dispatch('vedio/setSutoPlay', autoplay);
              console.log("当前音频"+(this.autoplay?"":"不")+"可以自动播放")
            }
        });
        // 用户点击交互之后，设置成能自动播放
        this.setAutoPlayWhenClick();
        //视频结束触发
        this.audio.addEventListener('ended', ()=> {
          if(this.replayNum<1){
            this.replayNum++;
            this.audio.play();
          }
          else{
            this.replayNum=0
            this.vedioIsPlaying = false
            this.$store.dispatch('vedio/setWarnPlayEnd', "1")
          }
        }, false)
        //
        this.audio.addEventListener('canplay', ()=> {
          console.log("音频总时间："+this.audio.duration)
        })
        //视频结束触发
        this.audio.addEventListener('timeupdate', ()=> {
          var timeDisplay;
          //用秒数来显示当前播放进度
          timeDisplay = Math.floor(this.audio.currentTime);
          let allDisplay=this.replayNum*this.audio.duration+timeDisplay;
          var popCut=this.vedioWarnDuration; //视频弹出时间,60秒
          // if(this.istestOnce) {//测试
          //     popCut=0;
          //     this.istestOnce=false;
          // }
          //当视频播放到 maxpopCut的时候做处理
          if(allDisplay >= popCut){
            this.vedioIsPlaying = false
            this.$store.dispatch('vedio/setWarnPlayEnd', "1")
            //this.audio.pause() //视频暂停 ,不需要：通过修改setWarnPlayEnd触发监控首页事件，控制暂停。
            //this.audio.currentTime=this.audio.duration;
          }
        }, false)
    },
    /** 监听页面的点击事件，一旦点过了就能autoplay了 */
    setAutoPlayWhenClick () {
        if(!this.autoplay){
            this.disabledAutoPlay();
            document.body.addEventListener('click', this.enabledAutoPlay)
            document.addEventListener('touchend', this.enabledAutoPlay);
        }
    },
    /**当前音频可自动播放 */
    enabledAutoPlay() {
       this.autoplay=true;
       document.removeEventListener('click', this.enabledAutoPlay);
       document.removeEventListener('touchend', this.enabledAutoPlay);
       this.$store.dispatch('vedio/setSutoPlay', true);
       console.log("当前音频"+(this.autoplay?"":"不")+"可以自动播放")
    },
    /**当前音频不能自动播放 */
    disabledAutoPlay() {
       this.autoplay=false;
    },
  }
}
</script>

<style lang="scss" scoped>
  .vediosvg{
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
    vertical-align: middle;
    color: #5a5e66;
    font-weight: 900;
    font-size: 22px;
  }
  .isforswitch{
    color: red;
  }
</style>
